export default {
  NOT_PURCHASE_ORDER: 'No PO #',

  SO_STATUS_ESTIMATE: 10,
  SO_STATUS_ISSUED: 20,
  SO_STATUS_IN_PROGRESS: 25,
  SO_STATUS_FULFILLED: 60,
  SO_STATUS_CLOSED: 70,
  SO_STATUS_VOIDED: 80,
  SO_STATUS_EXPIRED: 90,

  PICK_STATUS_ENTERED: 10,
  PICK_STATUS_STARTED: 20,
  PICK_STATUS_COMMITTED: 30,
  PICK_STATUS_FINISHED: 40,

  SHIP_STATUS_ENTERED: 10,
  SHIP_STATUS_PACKED: 20,
  SHIP_STATUS_SHIPPED: 30,
  SHIP_STATUS_CANCELLED: 40,

  PICK_ITEM_STATUS_SHORT: 5,
  PICK_ITEM_STATUS_HOLD: 6,
};



//////////////////
// WEBPACK FOOTER
// /constants.js
// module id = null
// module chunks = 